import axios from "axios";
import { API_END_POINT } from "../../constants/api";

import { returnErrors, clearErrors } from "./errorAction";

export const ADD_CONTRACT = "ADD_CONTRACT";
export const GET_CONTTRACT = "GET_CONTTRACT";
export const ADD_CONV_CONTRACT_FAIL = "ADD_CONV_CONTRACT_FAIL";
export const ADD_CONV_CONTRACT_SUCCESS = "ADD_CONV_CONTRACT_SUCCESS";
export const ADD_FABRIC_CONTRACT_FAIL = "ADD_FABRIC_CONTRACT_FAIL";
export const ADD_FABRIC_CONTRACT_SUCCESS = "ADD_FABRIC_CONTRACT_SUCCESS";
export const SALE_REGISTER = "SALE_REGISTER";

export const EDIT_FABRIC = "EDIT_FABRIC";
export const EDIT_FABRIC_SUCCESS = "EDIT_FABRIC_SUCCESS";
export const EDIT_FABRIC_FAIL = "EDIT_FABRIC_FAIL";

export const EDIT_CONVERSION = "EDIT_CONVERSION";
export const EDIT_CONVERSION_SUCCESS = "EDIT_CONVERSION_SUCCESS";
export const EDIT_CONVERSION_FAIL = "EDIT_CONVERSION_FAIL";

export const DELETE_CONVERSION = "DELETE_CONVERSION";
export const DELETE_CONVERSION_SUCCESS = "DELETE_CONVERSION_SUCCESS";
export const DELETE_CONVERSION_FAIL = "DELETE_CONVERSION_FAIL";

export const DELETE_CONTRACT = "DELETE_CONTRACT";
export const DELETE_CONTRACT_SUCCESS = "DELETE_CONTRACT_SUCCESS";
export const DELETE_CONTRACT_FAIL = "DELETE_CONTRACT_FAIL";

export function addContract(contractData) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    // editFabricComp

    const values = {
      ...contractData,
      fabric_contract: {
        ...contractData.fabric_contract,
        contract_date: contractData.fabric_contract.contract_date.format(
          "YYYY-MM-DD"
        ),
      },
      delivery_data: contractData["delivery_data"].map((schedule_date) => ({
        date: schedule_date.date.format("YYYY-MM-DD"),
        meter: schedule_date.meter,
      })),
    };
    const body = JSON.stringify(values);
    const url = `${API_END_POINT}/api/Contract/Fabric/Register`;
    axios
      .post(url, body, config)
      .then((res) =>
        dispatch({
          type: ADD_CONTRACT,
          payload: res.data[0],
        })
      )
      .then((data) =>
        dispatch(
          clearErrors(
            "fabric contract add Successfully",
            201,
            "ADD_FABRIC_CONTRACT_SUCCESS"
          )
        )
      )
      .then(() => dispatch(clearErrors()))
      .catch((err) =>
        dispatch(
          returnErrors(
            err.response.data,
            err.response.status,
            "ADD_FABRIC_CONTRACT_FAIL"
          )
        )
      )
      .then(() => dispatch(clearErrors()));
  };
}
export function editFabricComp(fabricEdit, contract_id) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    console.log(fabricEdit, contract_id);
    // editFabricComp

    // const values = {
    //   ...fabricEdit,
    //   fabric_contract: {
    //     ...fabricEdit.fabric_contract,
    //     contract_date: fabricEdit.fabric_contract.contract_date.format(
    //       "YYYY-MM-DD"
    //     ),
    //   },
    // };
    const body = JSON.stringify(fabricEdit);
    const url = `${API_END_POINT}/api/contract/fabric/update/${contract_id}`;
    console.log(body, "body");
    axios
      .put(url, body, config)
      .then((res) =>
        dispatch({
          type: EDIT_FABRIC,
          payload: res.data[0],
        })
      )
      .then((data) =>
        dispatch(
          clearErrors(
            "Fabric Contract Edit Successfully",
            201,
            "EDIT_FABRIC_SUCCESS"
          )
        )
      )
      .then(() => dispatch(clearErrors()))
      .catch((err) =>
        dispatch(
          returnErrors(
            err.response.data,
            err.response.status,
            "EDIT_FABRIC_FAIL"
          )
        )
      )
      .then(() => dispatch(clearErrors()));
  };
}

export function addConversion(conversionContract) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const values = {
      ...conversionContract,
      conversion_contract: {
        ...conversionContract.conversion_contract,
        contract_date: conversionContract.conversion_contract.contract_date.format(
          "YYYY-MM-DD"
        ),
      },
      delivery_data: conversionContract["delivery_data"].map(
        (schedule_date) => ({
          date: schedule_date.date.format("YYYY-MM-DD"),
          meter: schedule_date.meter,
        })
      ),
    };
    const body = JSON.stringify(values);
    const url = `${API_END_POINT}/api/Contract/Conversion/Register`;
    axios
      .post(url, body, config)
      .then((res) =>
        dispatch({
          type: ADD_CONTRACT,
          payload: res.data[0],
        })
      )
      .then((data) =>
        dispatch(
          clearErrors(
            "conversion contract add Successfully",
            201,
            "ADD_CONV_CONTRACT_SUCCESS"
          )
        )
      )
      .then(() => dispatch(clearErrors()))
      .catch((err) =>
        dispatch(
          returnErrors(
            err.response.data,
            err.response.status,
            "ADD_CONV_CONTRACT_FAIL"
          )
        )
      )
      .then(() => dispatch(clearErrors()));
  };
}

export function editConversionComp(conversionEdit, contract_id) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    console.log(conversionEdit, contract_id);
    // editFabricComp

    // const values = {
    //   ...contractData,
    //   fabric_contract: {
    //     ...contractData.fabric_contract,
    //     contract_date: contractData.fabric_contract.contract_date.format(
    //       "YYYY-MM-DD"
    //     ),
    //   },
    //   delivery_data: contractData["delivery_data"].map((schedule_date) => ({
    //     date: schedule_date.date.format("YYYY-MM-DD"),
    //     meter: schedule_date.meter,
    //   })),
    // };
    const body = JSON.stringify(conversionEdit);
    const url = `${API_END_POINT}/api/contract/conversion/update/${contract_id}`;
    axios
      .put(url, body, config)
      .then((res) =>
        dispatch({
          type: EDIT_CONVERSION,
          payload: res.data[0],
        })
      )
      .then((data) =>
        dispatch(
          clearErrors(
            "Conversion Contract Editing Successfully",
            201,
            "EDIT_CONVERSION_SUCCESS"
          )
        )
      )
      .then(() => dispatch(clearErrors()))
      .catch((err) =>
        dispatch(
          returnErrors(
            err.response.data,
            err.response.status,
            "EDIT_CONVERSION_FAIL"
          )
        )
      )
      .then(() => dispatch(clearErrors()));
  };
}
export function deleteContract(contract_id, company_id, type) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    console.log(contract_id, company_id, type);

    const NumbeCompany_id = parseInt(company_id);
    const NumberContract_id = parseInt(contract_id);

    const url = `${API_END_POINT}/api/contract/${type}/delete/${NumberContract_id}/${NumbeCompany_id}`;
    axios
      .delete(url, config)
      .then(
        (res) => console.log("res from delete fabric", res)
        // dispatch({
        //   type: DELETE_CONTRACT,
        //   payload: res.data[0],
        // })
      )
      .then((data) =>
        dispatch(
          clearErrors(
            "Contract Delete Successfully",
            201,
            "DELETE_CONTRACT_SUCCESS"
          )
        )
      )
      .then(() => dispatch(clearErrors()))
      .catch((err) =>
        dispatch(
          returnErrors(
            err.response.data,
            err.response.status,
            "DELETE_CONTRACT_FAIL"
          )
        )
      )
      .then(() => dispatch(clearErrors()));
  };
}
export function getContracts(company_id) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const url = `${API_END_POINT}/api/Contract/All`;
    axios
      .post(
        url,
        {
          company_id: company_id,
        },
        config
      )
      .then((res) =>
        dispatch({
          type: GET_CONTTRACT,
          payload: res.data,
        })
      )
      .catch((err) => {
        console.log(err);
      });
  };
}

export function saleRegister(company_id) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const url = `${API_END_POINT}/api/contract/invoice/list/${company_id}`;
    axios
      .get(url, config)
      .then((res) =>
        dispatch({
          type: SALE_REGISTER,
          payload: res.data,
        })
      )
      .catch((err) => {
        console.log(err);
      });
  };
}
